import React from "react";
import type { GenericRCAFormData } from "./types";

interface RCASynopsisSectionProps {
  formData: Pick<GenericRCAFormData, "incidentSynopsis" | "observations" | "summary" | "identifiedCause">;
  onChange: (field: keyof GenericRCAFormData, value: string) => void;
  readOnly: boolean;
}

const RCASynopsisSection: React.FC<RCASynopsisSectionProps> = ({
  formData,
  onChange,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">
        C. Incident Synopsis, Observations & Summary
      </h3>
      <div>
        <label className="block text-sm font-medium mb-1">
          Incident Synopsis <span className="text-red-500">*</span>
        </label>
        <textarea
          value={formData.incidentSynopsis}
          onChange={(e) => onChange("incidentSynopsis", e.target.value)}
          className="w-full p-2 border rounded"
          rows={4}
          required
          readOnly={readOnly}
          placeholder="Describe the event, sequence with scenario and time, include any harm that resulted"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Observations</label>
        <textarea
          value={formData.observations}
          onChange={(e) => onChange("observations", e.target.value)}
          className="w-full p-2 border rounded"
          rows={3}
          readOnly={readOnly}
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Summary</label>
        <textarea
          value={formData.summary}
          onChange={(e) => onChange("summary", e.target.value)}
          className="w-full p-2 border rounded"
          rows={3}
          readOnly={readOnly}
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          Identified Cause (if known)
        </label>
        <textarea
          value={formData.identifiedCause}
          onChange={(e) => onChange("identifiedCause", e.target.value)}
          className="w-full p-2 border rounded"
          rows={2}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};

export default RCASynopsisSection;
